import { useEffect } from 'react'

/**
 * Injects @font-face rules using the WordPress plugin assetsUrl.
 * This runs once on mount and handles both dev and production modes.
 */
export const useFontInjection = () => {
  useEffect(() => {
    const assetsUrl = window.campaignParams?.assetsUrl?.replace(/\/$/, '') ?? ''
    if (!assetsUrl) return

    const fontsBase = `${assetsUrl}/fonts`

    const css = `
      @font-face {
        font-family: 'FbAsli';
        src: url('${fontsBase}/FbAsli-Regular.otf') format('opentype');
        font-weight: 400; font-style: normal; font-display: swap;
      }
      @font-face {
        font-family: 'FbAsli';
        src: url('${fontsBase}/FbAsli-Bold.otf') format('opentype');
        font-weight: 700; font-style: normal; font-display: swap;
      }
      @font-face {
        font-family: 'FbAsli';
        src: url('${fontsBase}/FbAsli-Light.otf') format('opentype');
        font-weight: 300; font-style: normal; font-display: swap;
      }
      @font-face {
        font-family: 'Almoni';
        src: url('${fontsBase}/almoni-thin-aaa.otf') format('opentype');
        font-weight: 100; font-style: normal; font-display: swap;
      }
      @font-face {
        font-family: 'Almoni';
        src: url('${fontsBase}/almoni-ultralight-aaa.otf') format('opentype');
        font-weight: 200; font-style: normal; font-display: swap;
      }
    `

    const existing = document.getElementById('campaign-fonts')
    if (existing) return

    const style = document.createElement('style')
    style.id = 'campaign-fonts'
    style.textContent = css
    document.head.appendChild(style)
  }, [])
}
